import type { StaffDto } from '@genoma/shared';

import { useI18n } from '../../i18n/index.tsx';
import {
  createStaff,
  fetchStaff,
  inviteStaff,
  updateStaff,
} from '../../services/dashboard.service.ts';
import { StaffSection } from './StaffSection.tsx';

/**
 * The client's own P&O accounts.
 *
 * Managed exactly like coaches, which is why this file is configuration rather
 * than code: the mechanism is shared, and what makes P&O different is their
 * permission list, not their screen.
 *
 * Admin only. These are the client's people and their access is the
 * consultancy's to issue — and P&O themselves hold no permission that writes
 * anything, so there would be nobody else to show it to.
 */
export const PeoplePage = () => {
  const { t } = useI18n();

  return (
    <StaffSection<StaffDto>
      title={t('staff.title')}
      subtitle={(count) => t('staff.subtitle', { count })}
      emptyKey="staff.none"
      newKey="staff.new"
      helpKey="staff.createHelp"
      footerKey="staff.footer"
      canManage
      load={() => fetchStaff().then((data) => data.staff)}
      create={createStaff}
      // Corrected in the row: a P&O account has nothing else to manage, so
      // there is no screen of its own to send somebody to for one field.
      update={updateStaff}
      invite={inviteStaff}
    />
  );
};
